module.exports = __webpack_public_path__ + "static/media/NotasFiscais12.7a8d608b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancNotasFiscais/NotasFiscais12.png
// module id = 2143
// module chunks = 0